// src/components/common/PageHeader.js - WITH NIS LOGO ON LEFT
import React from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import nisLogoWithText from '../../assets/images/immgrationlogo1.png';

const PageHeader = ({ 
  title, 
  subtitle, 
  onBack, 
  actions = [],
  showBackButton = true,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        gap: 2,
      }}
    >
      {/* Left side - Back Button, Logo, and Title */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {showBackButton && onBack && (
          <IconButton 
            onClick={onBack}
            sx={{ 
              '&:hover': { 
                backgroundColor: 'action.hover' 
              } 
            }}
          >
            <BackIcon />
          </IconButton>
        )}
        
        {/* NIS Logo - Always visible on left */}
        <Box
          component="img"
          src={nisLogoWithText}
          alt="Nigeria Immigration Service"
          sx={{
            height: 45,
            width: 'auto',
            objectFit: 'contain',
            mr: 0.5,
          }}
        />
        
        {/* Title and Subtitle */}
        <Box>
          <Typography 
            variant="h6" 
            component="h1" 
            fontWeight="600"
            sx={{ 
              color: '#00a651', 
              lineHeight: 1.2,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontSize: '1.1rem'
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography 
              variant="body2" 
              sx={{ 
                mt: 0.5, 
                color: 'text.secondary',
                fontSize: '0.875rem'
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Right side - Action Buttons */}
      {actions.length > 0 && (
        <Box sx={{ display: 'flex', gap: 2 }}>
          {actions.map((action, index) => (
            <Button
              key={index}
              variant={action.variant || 'contained'}
              startIcon={action.icon}
              onClick={action.onClick}
              color={action.color || 'primary'}
              disabled={action.disabled}
            >
              {action.label}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;